import type { TelegramAuthV5Response, TelegramConfigResponse } from './types';

import { URL } from 'app/api/constants';
import type { ServiceConfig } from 'app/api/utils/create-http-api-service';
import { httpApiService } from 'app/api/utils/create-http-api-service';
import { defaultRequestService } from 'app/api/utils/default-request-service';

export const getTelegramAuthConfig = (config: ServiceConfig) => {
  type AdapterProps = { response: TelegramConfigResponse };

  return defaultRequestService<AdapterProps>(URL.AUTH_TELEGRAM_LINK, config.instance.get);
};

export const tryTelegramAuth = (telegramLoginRequestId: string) => {
  type AdapterProps = { response: TelegramAuthV5Response };

  return defaultRequestService<AdapterProps>(URL.AUTH_V5, httpApiService.post, {
    requestData: {
      telegramLoginRequestId,
    },
  });
};
